import { render } from "./SdgsView.vue?vue&type=template&id=35d5fdba"
import script from "./SdgsView.vue?vue&type=script&lang=js"
export * from "./SdgsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__